import React from 'react';
import TooltipExp from '@ecs/tng-common/components/tooltip/TooltipExp';
import { advertiserDisclosure } from '@ecs/tng-common/documents/disclosures/cm-disclosures';

interface TopAdvertiserDisclosureProps {
  className?: string;
}
class TopAdvertiserDisclosure extends React.Component<TopAdvertiserDisclosureProps> {
  render() {
    return (
      <div className="container">
        <TooltipExp
          id="art-disc"
          body={advertiserDisclosure}>
          <button
            type="button"
            className={`btn btn-link ms-auto d-flex align-items-center body-text-sm ${this.props.className || ''}`}>
            Advertiser Disclosure
            <span className="ecs-font-icon-act-info font-icon-size-md ps-1" />
          </button>
        </TooltipExp>
      </div>
    );
  }
}
export default TopAdvertiserDisclosure;
